export default "assets/images/icons/download-325288f8.svg";